import { render, staticRenderFns } from "./EditCompanyEmailModal.vue?vue&type=template&id=20953631&scoped=true&"
import script from "./EditCompanyEmailModal.vue?vue&type=script&lang=js&"
export * from "./EditCompanyEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyEmailModal.vue?vue&type=style&index=0&id=20953631&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20953631",
  null
  
)

export default component.exports